<template>
  <div class="d-flex flex-row">
    <v-card
      :min-width="size"
      ripple
      :height="size"
      class="mx-1 d-flex align-center justify-center pointer"
      outlined
      @click="$emit('input', value - 1)"
      :disabled="value === 1"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-card>

    <template v-for="(page, index) in items">
      <v-card
        v-if="page > 0"
        :min-width="size"
        :height="size"
        elevation="0"
        ripple
        outlined
        :key="index"
        @click="$emit('input', page)"
        class="mx-1"
        :color="page === value ? 'primary' : ''"
        :class="[
        'd-flex',
            'align-center',
            'justify-center',
            page === value ? 'white--text' : 'grey--text',
            'title'
          ]"
      >{{ page }}</v-card>
      <v-card
        v-else
        :min-width="size"
        :height="size"
        elevation="0"
        :key="index"
        class="d-flex justify-center"
      >...</v-card>
    </template>

    <v-card
      :disabled="length <= value"
      :min-width="size"
      ripple
      :height="size"
      class="mx-1 d-flex align-center justify-center pointer"
      outlined
      @click="$emit('input', value + 1)"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["length", "value"],
  data: () => ({
    visible: 7,
    size: 32
  }),
  computed: {
    items() {
      let items = [];
      let left = this.visible - 1;

      items.push(1);
      //add tail
      if (items.indexOf(this.length) === -1 && this.length > 0) {
        items.push(this.length);
        left = left - 1;
      }

      //add head
      if (items.indexOf(this.value) === -1 && this.value > 0) {
        items.push(this.value);
        left = left - 1;
      }

      let edge = 1;
      let hasNew;
      do {
        hasNew = false;
        //add paging to right
        if (
          this.value + edge < this.length &&
          items.indexOf(this.value + edge) === -1 &&
          left > 0
        ) {
          items.push(this.value + edge);
          left = left - 1;
          hasNew = true;
        }

        //add paging to left
        if (
          this.value - edge > 1 &&
          items.indexOf(this.value - edge) === -1 &&
          left > 0
        ) {
          items.push(this.value - edge);
          left = left - 1;
          hasNew = true;
        }
        edge++;
      } while (left > 0 && hasNew);

      items.sort((el1, el2) => {
        return parseInt(el1) - parseInt(el2);
      });
      if (items.length > 2 && items[0] + 1 !== items[1]) {
        items[1] = 0;
      }

      if (
        items.length > 2 &&
        items[items.length - 2] + 1 !== items[items.length - 1]
      ) {
        items[items.length - 2] = 0;
      }
      return items;
    }
  }
};
</script>
